import * as React from 'react'

interface Props {
  className?: string
  style?: React.CSSProperties
  focused: boolean
  label: string
  children?: React.ReactNode
}

export const FloatingLabelContainer: React.FC<Props> = props => {
  return (
    <div title={props.label} className={props.className} style={props.style}>
      <div className={`floating-label-container-label ${props.focused ? 'focused' : ''}`}>
        <div className="floating-label-container-text">{props.label}</div>
      </div>
      {props.children}
    </div>
  )
}
